import { type CatalogProduct } from "@/domain/catalog";
import { type AddToCartButtonState } from "./AddToCartButtonView";

export interface AddToCartStateInput {
	isConsultant?: boolean;
	loading?: boolean;
	error?: string | null;
	submitted?: boolean;
}

/**
 * Add-to-Cart button state. Audience/lifecycle gates win, then
 * loading → success → error → idle.
 */
export function deriveAddToCartState(
	product: Pick<
		CatalogProduct,
		"status" | "outOfStock" | "hostOnly" | "consultantOnly"
	>,
	input: AddToCartStateInput = {}
): AddToCartButtonState {
	const {
		isConsultant = false,
		loading = false,
		error = null,
		submitted = false
	} = input;

	if (product.consultantOnly && !isConsultant) {
		return { kind: "consultant-only-gated" };
	}
	if (product.hostOnly) return { kind: "host-exclusive" };
	if (product.status === "discontinued") return { kind: "discontinued" };
	if (product.outOfStock) return { kind: "out-of-stock" };
	if (loading) return { kind: "loading" };
	if (submitted) return { kind: "success" };
	if (error) return { kind: "error", message: error };
	return { kind: "idle" };
}

export function isCartDisabledByState(
	kind: AddToCartButtonState["kind"]
): boolean {
	return (
		kind === "out-of-stock" ||
		kind === "discontinued" ||
		kind === "host-exclusive" ||
		kind === "consultant-only-gated"
	);
}
